import { actions } from './actions'

const initialState = {
  franjasHorarios: {
    data: [],
    loading: false,
    error: '',
  },
  ubicacionesHorarios: {
    data: [],
    loading: false,
    error: '',
  },
  franjaHorario: {
    data: null,
    loading: false,
    error: '',
  },
  franjasHorariosEditar: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
  ubicaciones: {
    data: [],
    loading: false,
    error: '',
  },
  ubicacionesHorariosNoEspecial: {
    data: [],
    loading: false,
    error: '',
  },
  ubicacionesHorariosMRW: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function franjasHorariosReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FRANJAS_HORARIOS_LOAD_REQUESTED:
      return { ...state, franjasHorarios: { ...state.franjasHorarios, loading: true } }
    case actions.FRANJAS_HORARIOS_LOAD_SUCCEEDED:
      return {
        ...state,
        franjasHorarios: { ...state.franjasHorarios, data: action.payload, loading: false },
      }
    case actions.FRANJAS_HORARIOS_LOAD_FILED:
      return {
        ...state,
        franjasHorarios: { ...state.franjasHorarios, loading: false, error: action.error },
      }
    case actions.FRANJA_HORARIO_INSERT_REQUESTED:
      return {
        ...state,
        franjasHorarios: { ...state.franjasHorarios, loading: true, error: '' },
      }
    case actions.FRANJA_HORARIO_INSERT_SUCCEEDED:
      return {
        ...state,
        franjasHorarios: {
          ...state.franjasHorarios,
          data: [].concat(action.payload, state.franjasHorarios.data),
          loading: false,
          error: '',
        },
      }
    case actions.FRANJA_HORARIO_INSERT_FILED:
      return {
        ...state,
        franjasHorarios: { ...state.franjasHorarios, loading: false, error: action.error },
      }
    case actions.FRANJA_HORARIO_UPDATE_REQUESTED:
      return {
        ...state,
        franjasHorarios: { ...state.franjasHorarios, loading: true, error: '' },
      }
    case actions.FRANJA_HORARIO_UPDATE_SUCCEEDED:
      return {
        ...state,
        franjasHorarios: {
          ...state.franjasHorarios,
          data: state.franjasHorarios.data.map(franja =>
            franja.id === action.payload.id ? action.payload : franja,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.FRANJA_HORARIO_UPDATE_FILED:
      return {
        ...state,
        franjasHorarios: { ...state.franjasHorarios, loading: false, error: action.error },
      }
    case actions.FRANJA_HORARIO_DELETE_REQUESTED:
      return {
        ...state,
        franjasHorarios: { ...state.franjasHorarios, loading: true, error: '' },
      }
    case actions.FRANJA_HORARIO_DELETE_SUCCEEDED:
      return {
        ...state,
        franjasHorarios: {
          ...state.franjasHorarios,
          data: state.franjasHorarios.data.filter(franja => franja.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.FRANJA_HORARIO_DELETE_FILED:
      return {
        ...state,
        franjasHorarios: { ...state.franjasHorarios, loading: false, error: action.error },
      }
    case actions.UBICACIONES_HORARIOS_LOAD_REQUESTED:
      return { ...state, ubicacionesHorarios: { ...state.ubicacionesHorarios, loading: true } }
    case actions.UBICACIONES_HORARIOS_LOAD_SUCCEEDED:
      return {
        ...state,
        ubicacionesHorarios: { ...state.ubicacionesHorarios, data: action.payload, loading: false },
      }
    case actions.UBICACIONES_HORARIOS_LOAD_FILED:
      return {
        ...state,
        ubicacionesHorarios: { ...state.ubicacionesHorarios, loading: false, error: action.error },
      }

    case actions.FRANJA_HORARIO_BY_ID_LOAD_REQUESTED:
      return { ...state, franjaHorario: { ...state.franjaHorario, loading: true } }
    case actions.FRANJA_HORARIO_BY_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        franjaHorario: { ...state.franjaHorario, data: action.payload, loading: false },
      }
    case actions.FRANJA_HORARIO_BY_ID_LOAD_FILED:
      return {
        ...state,
        franjaHorario: { ...state.franjaHorario, loading: false, error: action.error },
      }
    case actions.FRANJAS_HORARIOS_EDITAR_LOAD_REQUESTED:
      return { ...state, franjasHorariosEditar: { ...state.franjasHorariosEditar, loading: true } }
    case actions.FRANJAS_HORARIOS_EDITAR_LOAD_SUCCEEDED:
      return {
        ...state,
        franjasHorariosEditar: {
          ...state.franjasHorariosEditar,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.FRANJAS_HORARIOS_EDITAR_LOAD_FILED:
      return {
        ...state,
        franjasHorariosEditar: {
          ...state.franjasHorariosEditar,
          loading: false,
          error: action.error,
          reload: false,
        },
      }
    case actions.FRANJA_HORARIO_EDITAR_DELETE_REQUESTED:
      return {
        ...state,
        franjasHorariosEditar: { ...state.franjasHorariosEditar, loading: true, error: '' },
      }
    case actions.FRANJA_HORARIO_EDITAR_DELETE_SUCCEEDED:
      return {
        ...state,
        franjasHorariosEditar: {
          ...state.franjasHorariosEditar,
          data: state.franjasHorariosEditar.data.filter(
            franja => franja.limitarHorarioRangoId !== action.payload,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.FRANJA_HORARIO_EDITAR_DELETE_FILED:
      return {
        ...state,
        franjasHorariosEditar: {
          ...state.franjasHorariosEditar,
          loading: false,
          error: action.error,
        },
      }
    case actions.FECHA_HORARIO_INSERT_REQUESTED:
      return {
        ...state,
        franjasHorariosEditar: { ...state.franjasHorariosEditar, loading: true, error: '' },
      }
    case actions.FECHA_HORARIO_INSERT_SUCCEEDED:
      return {
        ...state,
        franjasHorariosEditar: {
          ...state.franjasHorariosEditar,
          loading: false,
          error: '',
          reload: true,
        },
      }
    case actions.FECHA_HORARIO_INSERT_FILED:
      return {
        ...state,
        franjasHorariosEditar: {
          ...state.franjasHorariosEditar,
          loading: false,
          error: action.error,
        },
      }

    case actions.FRANJA_HORARIO_EDITAR_UPDATE_REQUESTED:
      return { ...state, franjasHorariosEditar: { ...state.franjasHorariosEditar, loading: true } }
    case actions.FRANJA_HORARIO_EDITAR_UPDATE_SUCCEEDED:
      return {
        ...state,
        franjasHorariosEditar: {
          ...state.franjasHorariosEditar,
          loading: false,
          reload: true,
        },
      }
    case actions.FRANJA_HORARIO_EDITAR_UPDATE_FILED:
      return {
        ...state,
        franjasHorariosEditar: {
          ...state.franjasHorariosEditar,
          loading: false,
          error: action.error,
          reload: false,
        },
      }
    case actions.UBICACIONES_LOAD_REQUESTED:
      return { ...state, ubicaciones: { ...state.ubicaciones, loading: true } }
    case actions.UBICACIONES_LOAD_SUCCEEDED:
      return {
        ...state,
        ubicaciones: { ...state.ubicaciones, data: action.payload, loading: false },
      }
    case actions.UBICACIONES_LOAD_FILED:
      return {
        ...state,
        ubicaciones: { ...state.ubicaciones, loading: false, error: action.error },
      }
    case actions.UBICACIONES_HORARIOS_NO_ESPECIAL_LOAD_REQUESTED:
      return {
        ...state,
        ubicacionesHorariosNoEspecial: { ...state.ubicacionesHorariosNoEspecial, loading: true },
      }
    case actions.UBICACIONES_HORARIOS_NO_ESPECIAL_LOAD_SUCCEEDED:
      return {
        ...state,
        ubicacionesHorariosNoEspecial: {
          ...state.ubicacionesHorariosNoEspecial,
          data: action.payload,
          loading: false,
        },
      }
    case actions.UBICACIONES_HORARIOS_NO_ESPECIAL_LOAD_FILED:
      return {
        ...state,
        ubicacionesHorariosNoEspecial: {
          ...state.ubicacionesHorariosNoEspecial,
          loading: false,
          error: action.error,
        },
      }
    case actions.UBICACIONES_MRW_LOAD_REQUESTED:
      return {
        ...state,
        ubicacionesHorariosMRW: { ...state.ubicacionesHorariosMRW, loading: true },
      }
    case actions.UBICACIONES_MRW_LOAD_SUCCEEDED:
      return {
        ...state,
        ubicacionesHorariosMRW: {
          ...state.ubicacionesHorariosMRW,
          data: action.payload,
          loading: false,
        },
      }
    case actions.UBICACIONES_MRW_LOAD_FILED:
      return {
        ...state,
        ubicacionesHorariosMRW: {
          ...state.ubicacionesHorariosMRW,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
